/* eslint-disable */
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Chip, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import useModals from 'components/modals/useModal';
import { modals } from 'components/modals/Modals'; 
import MainCard from "components/MainCard";
import { useEnumApi } from "contexts/EnumApiContext";

const EquipmentGateway = ({info, equipmentGateways, setIsLoading, refreshGateways}) => {
    const { getEnumValueByEnumNameAndCode } = useEnumApi();
    const { t } = useTranslation();

    // modal 관련
    const { openModal } = useModals();
    let [alertMessage, setAlertMessage] = useState('');

    const handleAlertClick = () => {
        openModal(modals.alertModal, {
            onClose : () => {
            },
            message: alertMessage,
        });
    };

    // const [gateways, setGateways] = useState(null);
    // const gatewayList = ()=> {
    //     getGatewaysByQuery({instlYn:"false",size:400}).then((res)=>{
    //         if (res && res._embedded) {
    //             let gatewayAlls = res._embedded.iotGateways;
    //             let gatewayExcludes = gatewayAlls;
    //             if (equipmentGateways) {
    //                 gatewayExcludes = gatewayAlls.filter(x => {
    //                     return !equipmentGateways.some(other => other.id === x.id)
    //                 });
    //             }
    //             let gatewaySelects = [];
    //             gatewayExcludes.map(function(gateway, i) {
    //                 gatewaySelects.push({label:gateway.sn+(gateway.name ? "("+gateway.name+")":""), id:gateway.id})
    //             })
    //             setGateways(gatewaySelects);
    //         } else {
    //             setGateways([])
    //         }
    //     })
    // }

    // useEffect(()=>{
    //     gatewayList();
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // },[equipmentGateways])

    // 설비와 게이트웨이 관계 삭제
    const handleEquipmentGatewayDeleteBtnClick = (param) => {
        openModal(modals.confirmModal, {
        onSubmit: (value) => {
            // deleteEquipmentCategories(param).then((res) => {
            //      setIsLoading(false);
            //      refreshGateways();
            // }).catch((err) => {
            //     console.log(err);
            //     if (!err.response?.data?.message) {
            //         alertMessage = err.message;
            //         setAlertMessage(alertMessage);
            //         handleAlertClick();
            //     } else if (err.response.data.message) {
            //         alertMessage = err.response.data.message;
            //         setAlertMessage(alertMessage);
            //         handleAlertClick();
            //     }
            // });
            // gatewayList();
        },
        onClose: () => {
        //   console.log('close');
        },
        message: t('message.common.alert.delete.question'),
        });
        
    };

    // const onSubmit = (data, e) => {
    //     e.preventDefault();

    //     let body = {
    //         id : data.gatewayId,
    //         equipment : {
    //             id : info.id
    //         },
    //     };
        
    //     // console.log(body);
    //     openModal(modals.confirmModal, {
    //         onSubmit : (value) => {
    //             installEquipmentGateways(body).then((res) => {
    //                 refreshGateways();
    //             }).catch((err) => {
    //                 // console.log(err);
    //                 if (!err.response?.data?.message) {
    //                     alertMessage = err.message;
    //                     setAlertMessage(alertMessage);
    //                     handleAlertClick();
    //                 } else if (err.response.data.message) {
    //                     alertMessage = err.response.data.message;
    //                     setAlertMessage(alertMessage);
    //                     handleAlertClick();
    //                 }
    //             });
    //         },
    //         onClose : () => {
    //             console.log('close');
    //         },
    //         message: t('message.common.alert.write.question'),
    //     });
    // }

    // const handleChangeBtnClick = (id) => {
    //     const targetId = replaceGetValues("targetId_"+id);

    //     if (!targetId) {
    //         alertMessage = t('message.common.alert.modify.gateway.select');
    //         setAlertMessage(alertMessage);
    //         handleAlertClick();
    //         return;
    //     }

    //     let body = {
    //         id : id,
    //         targetId : targetId
    //     };
        
    //     openModal(modals.confirmModal, {
    //         onSubmit : (value) => {
    //             replaceEquipmentGateways(body).then((res) => {
    //                 setIsLoading(false);
    //                 refreshGateways();
    //             }).catch((err) => {
    //                 console.log(err);
    //                 if (!err.response?.data?.message) {
    //                     alertMessage = err.message;
    //                     setAlertMessage(alertMessage);
    //                     handleAlertClick();
    //                 } else if (err.response.data.message) {
    //                     alertMessage = err.response.data.message;
    //                     setAlertMessage(alertMessage);
    //                     handleAlertClick();
    //                 }
    //             });
    //             replaceReset();
    //         },
    //         onClose : () => {
    //             console.log('close');
    //         },
    //         message: t('message.common.alert.gateway.modify.question'),
    //     });
    // }

    if (info) {
        return (
            <div style={{marginTop:"10px"}}>
                <MainCard style={{marginTop:"10px"}}>
                        <div style={{marginBottom:"10px"}}>
                            <span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/report.png`} alt='' /></span>&nbsp;
                            <Chip label={t('message.common.chip.gateway.information')} style={{color:"#fff", backgroundColor:"#6a7075", borderRadius:"4px"}} />
                        </div>
                        <TableContainer style={{width:"100%"}}>
                            <Table sx={{ minWidth: 500 }} aria-label="simple table" className="list_table" >
                                <TableHead>
                                    <TableRow>
                                        <TableCell className="th" align="center" style={{width:"40px"}}>No.</TableCell>
                                        <TableCell className="th" align="center">{t('message.common.subtitle.manufacturing.company')}</TableCell>
                                        <TableCell className="th" align="center">S/N</TableCell>
                                        <TableCell className="th" align="center">MAC</TableCell>
                                        {/* <TableCell className="th" align="center">IP</TableCell>
                                        <TableCell className="th" align="center"></TableCell> */}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    { equipmentGateways && equipmentGateways.map(function(item, i) {
                                        return (
                                    <TableRow key={i}>
                                        <TableCell align="center" style={{width:"40px"}}>{equipmentGateways.length-i}</TableCell>
                                        {/* <TableCell align="center">{item.madeBy && getEnumValueByEnumNameAndCode("GatewayMF", item.madeBy) && getEnumValueByEnumNameAndCode("GatewayMF", item.madeBy)[0].title}</TableCell> */}
                                        <TableCell align="center">{item.madeBy}</TableCell>
                                        <TableCell align="center">{item.sn}</TableCell>
                                        <TableCell align="center">{item.wifiMacAdr}</TableCell>
                                        {/* <TableCell align="center">{item.apGwIp}</TableCell>
                                        <TableCell align="center">
                                            <Button variant="outlined" color="error" className="small_btn" onClick={()=>{
                                                handleEquipmentGatewayDeleteBtnClick(item.id);
                                            }}>{t('message.common.btn.delete')}</Button>
                                        </TableCell> */}
                                    </TableRow>
                                        )
                                    }) }
                                </TableBody>
                            </Table>
                        </TableContainer>
                </MainCard>
            </div>
        )
    }
}
export default EquipmentGateway;